import React, { useState, useEffect } from 'react';
import {
  ProductsPage,
  PageHeader,
  PageTitle,
  AddProductButton,
  ProductsStats,
  StatItem,
  StatNumber,
  StatLabel,
  ProductSide,
  ProductsFilters,
  SearchBox,
  SearchInput,
  CategoryFilter
} from '../../styles/ProductsStyles';
import { useDispatch, useSelector } from 'react-redux';
import { ComponentUpdate } from '../../store/slices/component';
import { AddBrand } from './AddBrand';
import { GetCategories, GetProducsByAdmin, GetDraftProducts, GetCategoryBrandsList, DeleteProducts, UpdateProductStatus, GetBrands, GetUnverificationsProducts } from '../../common/CommonApi';
import { AddSize } from './AddSize';
import { AddColor } from './AddColor';
import styled from 'styled-components';
import {
  BadgeCheck,
  Boxes,
  Eye,
  Image as ImageIcon,
  Layers3,
  Palette,
  PackagePlus,
  Pencil,
  Ruler,
  Search,
  Tags,
  Trash2
} from 'lucide-react';
import Swal from 'sweetalert2';
import { useNavigate, useSearchParams } from "react-router-dom";
import { Dropdown, Item } from '../../styles/common';

const PAGE_SIZE = 30;

const Products = () => {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);


  const [searchTerm, setSearchTerm] = useState('');
  const componentStores = useSelector((state) => state.component);
  const [filterCategory, setFilterCategory] = useState('All');
  const [filterBrand, setFilterBrand] = useState('All');
  const userProfile = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(
    searchParams.get("tab") === "drafts" ? "tab4" : "tab1"
  );
  const [products, setProducts] = useState([]);
  const [draftProducts, setDraftProducts] = useState([]);
  const [verifyingProducts, setVerifyingProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [viewModal, setVeiwModal] = useState(false);
  const [viewProductModal, setViewProductModal] = useState({});
  const [allBrandsCategory, setAllBrandsCategory] = useState({});
  const [variantModal, setVariantModal] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productsPagination, setProductsPagination] = useState({ page: 1, pages: 0, total: 0 });
  const [pendingPagination, setPendingPagination] = useState({ page: 1, pages: 0, total: 0 });
  const [draftPagination, setDraftPagination] = useState({ page: 1, pages: 0, total: 0 });
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const dispatch = useDispatch();
  const [badge] = useState(['trending','arrival'])

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (page = 1) => {
    try {
      setLoading(true)
      const productsResponse = await GetProducsByAdmin(userProfile._id, page, PAGE_SIZE);
      // console.log("productsResponse", productsResponse.data.data)
      if (productsResponse.data.message === 'DATA_FOUND') {
        const productsData = productsResponse.data.data;
        const productList = Array.isArray(productsData) ? productsData : productsData?.products || [];
        setProducts(productList);
        setProductsPagination(productsData?.pagination || { page, pages: 1, total: productList.length });
      }
      const draftProductsResponse = await GetDraftProducts(userProfile._id, page, PAGE_SIZE);
      if (draftProductsResponse.data.message === 'DATA_FOUND') {
        const draftsData = draftProductsResponse.data.data;
        const drafts = draftsData?.products || [];
        setDraftProducts(drafts);
        setDraftPagination(draftsData?.pagination || { page, pages: 1, total: drafts.length });
      }
      const verifyingProductsResponse = await GetUnverificationsProducts(userProfile._id,'product', page, PAGE_SIZE);
      if (verifyingProductsResponse.data.message === 'DATA_FOUND') {
        setVerifyingProducts(verifyingProductsResponse.data.data?.products || []);
        setPendingPagination(verifyingProductsResponse.data.data?.pagination || { page, pages: 0, total: 0 });
      }
      const categoriesResponse = await GetCategories();
      setCategories(categoriesResponse.data.data);
      const brandsResponse = await GetBrands(userProfile._id);
      if (brandsResponse.data.message === 'brands retrieved successfully') {
        setBrands(brandsResponse.data.data);
      }
      setLoading(false)
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false)
    }
  };

  const navigate = useNavigate();

  const filteredProducts = products.filter(product => {
    const matchesSearch = product.name?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = filterCategory === 'All' || product.category === filterCategory;
    const matchesBrand = filterBrand === 'All' || product.brandsId === filterBrand;
    return matchesSearch && matchesCategory && matchesBrand;
  });

  const filteredDraftProducts = draftProducts.filter(product => {
    const matchesSearch = product.name?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = filterCategory === 'All' || product.category === filterCategory;
    const matchesBrand = filterBrand === 'All' || product.brandsId === filterBrand;
    return matchesSearch && matchesCategory && matchesBrand;
  });

  const deleteProduct = async (product) => {
    // console.log("--->product", product)
    Swal.fire({
        title: 'Do you want to delete the product?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: 'No',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Swal.fire('Saved!', '', 'success')
          await DeleteProducts(product._id)
          fetchData()
        }
      })
  }

  const openVeiwModal = async (product) => {
    setViewProductModal(product); setVeiwModal(true);
    const resp = await GetCategoryBrandsList(product.brandsId, product.category, product.subcategory, product.adminId)
    if (resp.data.message === "DATA_FOUND") {
      setAllBrandsCategory(resp.data.data)
    }
  };

  const handleProductStatusChange = async (e,product) => {
    e.stopPropagation();
    const updatedStatus = !product.isActive;
    let resp = await UpdateProductStatus(product._id,{status:updatedStatus})
    if(resp.data.message === "SUCCESSFULLY_UPDATED"){
      Swal.fire("Status Updated")
      fetchData();
    }
    // console.log("--->handleProductStatusChange",e.target.value,product)
  }
  const handleProductBadgeChange = async (e,product) => {
    e.stopPropagation();
    const updatedStatus = e.target.value;
    let resp = await UpdateProductStatus(product._id,{status:updatedStatus,isBadge:true})
    if(resp.data.message === "SUCCESSFULLY_UPDATED"){
      Swal.fire("Badge Updated")
      fetchData();
    }
    // console.log("--->handleProductStatusChange",e.target.value,product)
  }

  const openEditHandle = (products) => {
    navigate(`/products/edit/?id=${products._id}`)
  }
  const openViewHandle = (products) => {
    navigate(`/products/view/?id=${products._id}`)
  }
  const AddProductHandle = () => {
    navigate(`/products/add`)
  }
  const openVariantModal = (product) => { setSelectedProduct(product); setVariantModal(true); };
  const openImageModal = (product, index) => { setSelectedProduct(product); setLightboxIndex(index); setImageModal(true); };
  const closeModal = () => { setVariantModal(false); setImageModal(false); };
  const prevImage = () => setLightboxIndex((i) => (i === 0 ? selectedProduct.variants[0].varientImages.length - 1 : i - 1));
  const nextImage = () => setLightboxIndex((i) => (i === selectedProduct.variants[0].varientImages.length - 1 ? 0 : i + 1));
  const activeProducts = filteredProducts.filter((data) => data.isActive);
  const inactiveProducts = filteredProducts.filter((data) => data.isActive === false);
  const filteredVerifyingProducts = verifyingProducts.filter(product => {
    const matchesSearch = product.name?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = filterCategory === 'All' || product.category === filterCategory;
    const matchesBrand = filterBrand === 'All' || product.brandsId === filterBrand;
    return matchesSearch && matchesCategory && matchesBrand;
  });
  const currentPagination = activeTab === 'tab3'
    ? pendingPagination
    : activeTab === 'tab4'
      ? draftPagination
      : productsPagination;
  const changeTab = (tab) => {
    setActiveTab(tab);
    const targetPagination = tab === 'tab3'
      ? pendingPagination
      : tab === 'tab4'
        ? draftPagination
        : productsPagination;
    if (targetPagination.page !== 1) fetchData(1);
  };
  // console.log("-->products",products)
  return (
    <>
      {componentStores.isBrandAddOpen && <AddBrand />}
      {componentStores.isSize && <AddSize />}
      {componentStores.isColor && <AddColor />}

      <ProductsPage>
        <PageHeader>
          <PageHeading>
            <PageTitle>Products Management</PageTitle>
            <PageSubtitle>Manage catalog items, inventory variants, badges, and visibility.</PageSubtitle>
          </PageHeading>
          <ProductSide>
            <ToolbarButton onClick={() =>
              dispatch(ComponentUpdate({
                isSize: true
              }))
            }><Ruler size={16} /> Size</ToolbarButton>
            <ToolbarButton onClick={() =>
              dispatch(ComponentUpdate({
                isColor: true
              }))
            }><Palette size={16} /> Color</ToolbarButton>
            <ToolbarButton onClick={() =>
              dispatch(ComponentUpdate({
                isBrandAddOpen: true
              }))
            }><Tags size={16} /> Brand</ToolbarButton>
            <AddProductButton onClick={() =>
              AddProductHandle()
            }><PackagePlus size={16} /> Add Product</AddProductButton>
          </ProductSide>
        </PageHeader>

        <ProductsStats>
          <StatItem>
            <StatNumber>{products.length + verifyingProducts.length + draftProducts.length}</StatNumber>
            <StatLabel>Total Products</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>{products.filter(p => p.isActive).length}</StatNumber>
            <StatLabel>Active Products</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>{verifyingProducts.length}</StatNumber>
            <StatLabel>For Verifying</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>{draftProducts.length}</StatNumber>
            <StatLabel>Drafts</StatLabel>
          </StatItem>
          <StatItem>
            <StatNumber>{products.reduce((sum, p) => sum + p.variants.reduce((s, v) => s + (v.quantity || 0), 0), 0)}</StatNumber>
            <StatLabel>Total Stock</StatLabel>
          </StatItem>
        </ProductsStats>

        <ProductsFilters>
          <SearchBox>
            <Search size={16} color="#64748b" />
            <SearchInput
              type="text"
              placeholder="Search products..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </SearchBox>

          <CategoryFilter
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
          >
            <option value="All">All Categories</option>
            {categories.map(cat => (
              <option key={cat._id} value={cat._id}>{cat.categoryName}</option>
            ))}
          </CategoryFilter>

          <CategoryFilter
            value={filterBrand}
            onChange={(e) => setFilterBrand(e.target.value)}
          >
            <option value="All">All Brands</option>
            {brands.map(brand => (
              <option key={brand._id} value={brand._id}>{brand.brandName}</option>
            ))}
          </CategoryFilter>
        </ProductsFilters>
        {/* <TabsContainer> */}
        {/* Tab Headers */}
        <TabsWrapper style={{ marginTop: "10px" }}>
          {/* Tabs */}
          <TabHeader>
            <TabButton active={activeTab === "tab1"} onClick={() => changeTab("tab1")}>
              <span className="tab-label tab-label-full">Active Products</span>
              <span className="tab-label tab-label-mobile">Active</span>
              <TabCount>{activeProducts.length}</TabCount>
            </TabButton>
            <TabButton active={activeTab === "tab2"} onClick={() => changeTab("tab2")}>
              <span className="tab-label tab-label-full">Inactive Products</span>
              <span className="tab-label tab-label-mobile">Inactive</span>
              <TabCount>{inactiveProducts.length}</TabCount>
            </TabButton>
            <TabButton active={activeTab === "tab3"} onClick={() => changeTab("tab3")}>
              <span className="tab-label tab-label-full">In Pending</span>
              <span className="tab-label tab-label-mobile">Pending</span>
              <TabCount>{filteredVerifyingProducts.length}</TabCount>
            </TabButton>
            <TabButton active={activeTab === "tab4"} onClick={() => changeTab("tab4")}>
              <span className="tab-label tab-label-full">Drafts</span>
              <span className="tab-label tab-label-mobile">Drafts</span>
              <TabCount>{filteredDraftProducts.length}</TabCount>
            </TabButton>
          </TabHeader>
          {activeTab === "tab1" && (
            fileterData(activeProducts,allBrandsCategory,viewProductModal,selectedProduct,viewModal,openImageModal,openVariantModal,openVeiwModal,null,deleteProduct,setVeiwModal,variantModal,closeModal,handleProductStatusChange,imageModal,lightboxIndex,prevImage,nextImage,openEditHandle,loading,openViewHandle,badge,handleProductBadgeChange)
          )}
          {activeTab === "tab2" && (
            fileterData(inactiveProducts,allBrandsCategory,viewProductModal,selectedProduct,viewModal,openImageModal,openVariantModal,openVeiwModal,null,deleteProduct,setVeiwModal,variantModal,closeModal,handleProductStatusChange,imageModal,lightboxIndex,prevImage,nextImage,openEditHandle,loading,openViewHandle,badge,handleProductBadgeChange)
          )}
          {activeTab === "tab3" && (
            fileterData(filteredVerifyingProducts,allBrandsCategory,viewProductModal,selectedProduct,viewModal,openImageModal,openVariantModal,openVeiwModal,null,deleteProduct,setVeiwModal,variantModal,closeModal,handleProductStatusChange,imageModal,lightboxIndex,prevImage,nextImage,openEditHandle,loading,openViewHandle,badge,handleProductBadgeChange)
          )}
          {activeTab === "tab4" && (
            fileterData(filteredDraftProducts,allBrandsCategory,viewProductModal,selectedProduct,viewModal,openImageModal,openVariantModal,openVeiwModal,null,deleteProduct,setVeiwModal,variantModal,closeModal,handleProductStatusChange,imageModal,lightboxIndex,prevImage,nextImage,openEditHandle,loading,openViewHandle,badge,handleProductBadgeChange)
          )}
        </TabsWrapper>
        <PaginationBar>
          <span>Page {currentPagination.page || 1} of {currentPagination.pages || 1} · {currentPagination.total} products</span>
          <div>
            <button type="button" disabled={loading || currentPagination.page <= 1} onClick={() => fetchData(currentPagination.page - 1)}>← Previous</button>
            <button type="button" disabled={loading || !currentPagination.pages || currentPagination.page >= currentPagination.pages} onClick={() => fetchData(currentPagination.page + 1)}>Next →</button>
          </div>
        </PaginationBar>
        {/* </TabsContainer> */}
      </ProductsPage>
    </>
  );
};


const fileterData = (products,allBrandsCategory,viewProductModal,selectedProduct,viewModal,openImageModal,openVariantModal,openVeiwModal,openVerifyModal,deleteProduct,setVeiwModal,variantModal,closeModal,handleProductStatusChange,imageModal,lightboxIndex,prevImage,nextImage,openEditHandle,loading,openViewHandle,badge,handleProductBadgeChange) => {
  const getVariantImages = (product) => product?.variants?.[0]?.varientImages || product?.images || [];
  const getTotalStock = (product) => (product?.variants || []).reduce((sum, variant) => sum + (Number(variant.quantity) || 0), 0);
  const getDescription = (description = "") => {
    const trimmed = description.trim();
    if (!trimmed) return "No description added";
    return trimmed.split(" ").slice(0, 12).join(" ") + (trimmed.split(" ").length > 12 ? " ..." : "");
  };

  return (
    <Wrapper>
      <Table>
        <Header>
          <div>Product</div>
          <div>Details</div>
          <div>Price</div>
          <div>Status</div>
          <div>Inventory / Badge</div>
          <div>Actions</div>
        </Header>
        {loading && (
          <LoadingState>
            <img src="/assets/loading.gif" alt="Loading products" />
          </LoadingState>
        )}
        {!loading && products.length === 0 && (
          <EmptyState>
            <Boxes size={34} />
            <strong>No products found</strong>
            <span>Try changing the search, category, or active tab.</span>
          </EmptyState>
        )}
        {!loading && products.map((product) => {
          const images = getVariantImages(product);
          const totalStock = getTotalStock(product);
          const firstVariant = product?.variants?.[0] || {};

          return (
          <Row key={product._id}>
            <ProductMedia onClick={() => images.length && openImageModal(product, 0)}>
              {images[0] ? (
                <img src={images[0]} alt={product.name || "Product"} />
              ) : (
                <ImagePlaceholder>
                  <ImageIcon size={22} />
                </ImagePlaceholder>
              )}
              {images.length > 1 && <ImageCount>+{images.length - 1}</ImageCount>}
            </ProductMedia>
            <ProductDetailsCell>
              <ProductName>{product.name}</ProductName>
              <ProductDesc>{getDescription(product.description)}</ProductDesc>
            </ProductDetailsCell>
            <PriceStack>
              {firstVariant?.disCountedprice && (
                <DiscountedPrice>Rs. {firstVariant.disCountedprice}</DiscountedPrice>
              )}
              <Price>{firstVariant?.price ? `Rs. ${firstVariant.price}` : "No price"}</Price>
            </PriceStack>
            <StatusStack>
              <Status verified={product.verificationStatus}>
                {product.verificationStatus && !product.isDraft ? <BadgeCheck size={14} /> : null}
                {product.isDraft ? "Draft" : product.verificationStatus ? "Verified" : "Pending"}
              </Status>
              {!product.isDraft && (
                <StatusButton type="button" onClick={(e) => handleProductStatusChange(e,product)} verified={product.isActive}>{product.isActive ? "Enabled" : "Disabled"}</StatusButton>
              )}
            </StatusStack>
            <MetaStack>
              <InventoryCell>
                <strong>{totalStock}</strong>
                <span>{product?.variants?.length || 0} variants</span>
              </InventoryCell>
              {!product.isDraft && (
                <BadgeSelect
                  name="category"
                  value={product.isBadge || ""}
                  onChange={(e) => handleProductBadgeChange(e, product)}
                >
                  <Item value="">Select</Item>
                  {badge.map((data, index) => (
                    <Item key={index} value={data}>
                      {data.toUpperCase()}
                    </Item>
                  ))}
                </BadgeSelect>
              )}
            </MetaStack>
            <RowActions>
              <IconAction type="button" title="View variants" aria-label="View variants" onClick={() => openVariantModal(product)}>
                <Layers3 size={16} />
              </IconAction>
              <IconAction type="button" title="View product" aria-label="View product" onClick={() => openViewHandle(product)}>
                <Eye size={16} />
              </IconAction>
              <IconAction type="button" title="Edit product" aria-label="Edit product" onClick={() => openEditHandle(product)}>
                <Pencil size={16} />
              </IconAction>
              <IconAction type="button" title="Delete product" aria-label="Delete product" danger onClick={() => deleteProduct(product, false)}>
                <Trash2 size={16} />
              </IconAction>
            </RowActions>
          </Row>
        )})}
      </Table>

      {/* Variant Modal */}
      {variantModal && selectedProduct && (
        <ModalOverlay>
          <Modal>
            <ModalTitle>Variants of {selectedProduct.name}</ModalTitle>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5', textAlign: 'left' }}>
                  <th style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>Size</th>
                  <th style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>Color</th>
                  <th style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>Quantity</th>
                  <th style={{ padding: '12px', borderBottom: '1px solid #ddd' }}>SKU</th>
                </tr>
              </thead>
              <tbody>
                {selectedProduct.variants.map((v, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '10px' }}>{v.size}</td>
                    <td style={{ padding: '10px' }}>{v.color}</td>
                    <td style={{ padding: '10px' }}>{v.quantity}</td>
                    <td style={{ padding: '10px' }}>{v.sku}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <ModalActions>
              <Button type="delete" onClick={closeModal}>Close</Button>
            </ModalActions>
          </Modal>
        </ModalOverlay>
      )}

      {/* {viewModal &&
        <ModalOverlay style={{zIndex:999}}>
          <Modal style={{ width: "800px" }}>
            <ModalTitle>Product Details</ModalTitle>
            <InfoGrid>
              <InfoItem>
                <Label>Full Name</Label>
                <Value>{viewProductModal.name}</Value>
              </InfoItem>
              <InfoItem>
                <Label>Short Description</Label>
                <Value>{viewProductModal.shortDescription}</Value>
              </InfoItem>
              <InfoItem>
                <Label>Description</Label>
                <Value>{viewProductModal.description}</Value>
              </InfoItem>
              <InfoItem>
                <Label>Product Details</Label>
                <Value>{viewProductModal.productDetails}</Value>
              </InfoItem>
              <InfoItem>
                <Label>Created Date</Label>
                <Value>{new Date(viewProductModal?.createdDate).toLocaleString()}</Value>
              </InfoItem>
              <InfoItem>
                <Label>HSN Tax Code</Label>
                <Value>{viewProductModal.HsnTaxCode}</Value>
              </InfoItem>
              <InfoItem>
                <Label>Style Tag</Label>
                <Value>{viewProductModal.styleTags}</Value>
              </InfoItem>
              <InfoItem>
                <Label>Careinstructions</Label>
                <Value>{viewProductModal.careInstructions}</Value>
              </InfoItem>
              <InfoItem>
                <Label>Season</Label>
                <Value>{viewProductModal.season}</Value>
              </InfoItem>
              <InfoItem>
                <Label>Product Added By</Label>
                <Value>{allBrandsCategory?.AdminDetails?.fullname}</Value>
              </InfoItem>
              <InfoItem>
                <Label>Brands</Label>
                <Value>{allBrandsCategory?.Brands?.brandName}</Value>
                <Label>Brands Description</Label>
                <Value>{allBrandsCategory?.Brands?.brandDescription}</Value>
                <Label>Image</Label>
                <Value><img src={allBrandsCategory?.Brands?.brandImage} style={{ width: "70px" }} /></Value>
              </InfoItem>
              <InfoGrid>
                <InfoItem>
                  <Label>Category</Label>
                  <Value>{allBrandsCategory?.Category?.categoryName}</Value>
                  <Label>Brands Description</Label>
                  <Value>{allBrandsCategory?.Category?.description}</Value>
                  <Label>Image</Label>
                  <Value><img src={allBrandsCategory?.Category?.categoryImage} style={{ width: "70px" }} /></Value>
                </InfoItem>
                <InfoItem>
                  <Label>Sub Category</Label>
                  <Value>{allBrandsCategory?.SubCategory?.subcategoryName}</Value>
                  <Label>Brands Description</Label>
                  <Value>{allBrandsCategory?.SubCategory?.description}</Value>
                  <Label>Image</Label>
                  <Value><img src={allBrandsCategory?.SubCategory?.subcategoryImage} style={{ width: "70px" }} /></Value>
                </InfoItem>
              </InfoGrid>
            </InfoGrid>
            <ModalActions>
              <Button type="delete" onClick={() => setVeiwModal(false)}>Close</Button>
            </ModalActions>
          </Modal>
        </ModalOverlay>
      } */}

      {/* Image Carousel Modal */}
      {imageModal && selectedProduct && (
            <ModalOverlay>
              <Modal style={{ width: 'auto', maxWidth: '80%' }}>
                <img src={selectedProduct.variants[0].varientImages[lightboxIndex]} style={{ width: '500px', maxHeight: '70vh' }} alt="product" />
                <ModalActions>
                  <Button type="edit" onClick={prevImage}>Prev</Button>
                  <Button type="edit" onClick={nextImage}>Next</Button>
                  <Button type="delete" onClick={closeModal}>Close</Button>
                </ModalActions>
              </Modal>
            </ModalOverlay>
          )}
    </Wrapper>
  )
}

export default Products;



const PageHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const PageSubtitle = styled.p`
  color: #64748b;
  font-size: 14px;
  margin: 0;
`;

const PaginationBar = styled.div`
  align-items: center;
  color: #64748b;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-top: 20px;

  button { background: #fff; border: 1px solid #cbd5e1; border-radius: 6px; cursor: pointer; margin-left: 8px; padding: 9px 13px; }
  button:disabled { cursor: not-allowed; opacity: .5; }

  > div {
    display: flex;
    gap: 8px;
  }

  @media (max-width: 640px) {
    width: 100%;
    gap: 10px;
    margin-top: 14px;
    font-size: 12px;

    > span {
      white-space: nowrap;
    }

    button {
      min-height: 36px;
      margin-left: 0;
      padding: 7px 10px;
      white-space: nowrap;
    }
  }
`;

const ToolbarButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: #30d5c8;
    color: #0f766e;
    background: #f0fdfa;
  }
`;

const Wrapper = styled.div`
  padding: 18px;
  background: #f8fafc;
  overflow: hidden;
  max-width: 100%;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const Table = styled.div`
  width: 100%;
  border-radius: 8px;
  background: white;
  overflow: hidden;
  border: 1px solid #e2e8f0;
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: 78px minmax(0, 1.8fr) minmax(88px, 0.7fr) minmax(120px, 0.85fr) minmax(130px, 0.85fr) minmax(134px, 0.8fr);
  gap: 12px;
  align-items: center;
  padding: 13px 14px;
  background: #f8fafc;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
  font-weight: 800;
  font-size: 12px;
  text-transform: uppercase;

  @media (max-width: 1100px) {
    display: none;
  }
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 78px minmax(0, 1.8fr) minmax(88px, 0.7fr) minmax(120px, 0.85fr) minmax(130px, 0.85fr) minmax(134px, 0.8fr);
  gap: 12px;
  padding: 16px 14px;
  align-items: center;
  border-bottom: 1px solid #eef2f7;
  transition: background 0.2s ease;

  &:hover {
    background: #fbfdff;
  }

  &:last-child {
    border-bottom: 0;
  }

  @media (max-width: 1100px) {
    grid-template-columns: 76px minmax(0, 1fr);
    align-items: flex-start;
    gap: 10px 12px;
    padding: 14px;

    ${Header} + & {
      border-top: 0;
    }
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 9px;
    padding: 10px;
  }
`;

const ProductMedia = styled.button`
  position: relative;
  width: 64px;
  height: 64px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 0;
  overflow: hidden;
  cursor: pointer;

  @media (max-width: 640px) {
    width: 100%;
    height: auto;
    max-height: 240px;
    aspect-ratio: 16 / 10;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const ImagePlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
`;

const ImageCount = styled.span`
  position: absolute;
  right: 5px;
  bottom: 5px;
  background: rgba(15, 23, 42, 0.78);
  color: #fff;
  border-radius: 6px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 800;
`;

const ProductDetailsCell = styled.div`
  min-width: 0;
`;

const ProductName = styled.div`
  font-weight: 800;
  font-size: 15px;
  color: #0f172a;
  margin-bottom: 5px;

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const ProductDesc = styled.div`
  font-size: 13px;
  line-height: 1.45;
  color: #64748b;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const PriceStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;

  @media (max-width: 1100px) {
    grid-column: 2;
  }

  @media (max-width: 640px) {
    grid-column: auto;
  }
`;

const Price = styled.div`
  color: #94a3b8;
  font-weight: 700;
  font-size: 12px;
  text-decoration: line-through;
`;

const DiscountedPrice = styled.div`
  color: #0f766e;
  font-size: 15px;
  font-weight: 900;
`;

const Status = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 800;
  color: ${({ verified }) => (verified ? "#056d3b" : "#a61b1b")};
  background: ${({ verified }) => (verified ? "#d4f5e9" : "#fde4e4")};
  padding: 7px 10px;
  border-radius: 999px;
  text-align: center;
  width: fit-content;
`;

const BadgeSelect = styled(Dropdown)`
  width: 100%;
  max-width: 112px;
  min-height: 36px;
  font-size: 12px;
  font-weight: 700;
  border-color: #cbd5e1;
`;

const StatusStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  @media (max-width: 1100px) {
    grid-column: 2;
    flex-direction: row;
    flex-wrap: wrap;
  }

  @media (max-width: 640px) {
    grid-column: auto;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const MetaStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  @media (max-width: 1100px) {
    grid-column: 2;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }

  @media (max-width: 640px) {
    grid-column: auto;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    width: 100%;
  }
`;

const StatusButton = styled.button`
  border: 0;
  cursor: pointer;
  font-size: 12px;
  font-weight: 800;
  color: ${({ verified }) => (verified ? "#056d3b" : "#a61b1b")};
  background: ${({ verified }) => (verified ? "#d4f5e9" : "#fde4e4")};
  padding: 8px 12px;
  border-radius: 999px;
  width: fit-content;
`;

const InventoryCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  strong {
    color: #0f172a;
    font-size: 16px;
  }

  span {
    color: #64748b;
    font-size: 12px;
    font-weight: 700;
  }
`;

const RowActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 1100px) {
    grid-column: 2;
  }

  @media (max-width: 640px) {
    grid-column: auto;
    flex-wrap: nowrap;
    width: 100%;

    > button {
      flex: 1;
    }
  }
`;

const IconAction = styled.button`
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid ${({ danger }) => (danger ? "#fecaca" : "#dbe3ef")};
  background: #fff;
  color: ${({ danger }) => (danger ? "#dc2626" : "#334155")};
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;

  &:hover {
    background: ${({ danger }) => (danger ? "#fef2f2" : "#f8fafc")};
    border-color: ${({ danger }) => (danger ? "#fca5a5" : "#94a3b8")};
  }
`;

const LoadingState = styled.div`
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 78px;
    height: 78px;
    object-fit: contain;
  }
`;

const EmptyState = styled.div`
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  color: #64748b;

  strong {
    color: #0f172a;
    font-size: 16px;
  }

  span {
    text-align: center;
  }

  @media (max-width: 640px) {
    min-height: 190px;
    padding: 24px 16px;
    text-align: center;

    strong {
      font-size: 15px;
    }

    span {
      max-width: 270px;
      font-size: 12px;
      line-height: 1.5;
    }
  }
`;

const Button = styled.button`
  padding: 6px 10px; border-radius: 6px; border: none; font-size: 13px; cursor: pointer;
  background: ${({ type }) => type === "verify" ? "#00b894" : type === "edit" ? "#0077ff" : "#e63946"};
  color: white; &:hover { opacity: 0.9; }
`;

// ---------- Modal ----------



const ModalOverlay = styled.div`
  position: fixed; top:0; left:0; width:100%; height:100%; background: rgba(0,0,0,0.45);
  display: flex; justify-content: center; align-items: center;
`;
const Modal = styled.div`
  background:white; width:400px; max-width:90%; padding:20px; border-radius:12px; box-shadow:0 4px 15px rgba(0,0,0,0.2);
`;
const ModalTitle = styled.h3`margin:0 0 10px 0; font-size:18px;`;
const ModalActions = styled.div`display:flex; justify-content:flex-end; gap:10px; margin-top:14px;`;

// Styled components
const TabsWrapper = styled.div`
  width: 100%;
  font-family: "Poppins", sans-serif;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
`;

// Tab header container
const TabHeader = styled.div`
  display: flex;
  gap: 8px;
  background: #f8fafc;
  padding: 8px;
  border-bottom: 1px solid #e2e8f0;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-wrap: nowrap;
    gap: 4px;
    overflow: hidden;
    padding: 6px;
  }
`;

// Individual tab button
const TabButton = styled.button`
  flex: 1 1 180px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 16px;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
  border: 1px solid ${(props) => (props.active ? "#30d5c8" : "transparent")};
  border-radius: 8px;
  outline: none;
  background: ${(props) => (props.active ? "#fff" : "transparent")};
  color: ${(props) => (props.active ? "#0f766e" : "#64748b")};
  transition: all 0.3s ease;

  .tab-label-mobile {
    display: none;
  }

  &:hover {
    background: #fff;
  }

  @media (max-width: 768px) {
    flex: 1 1 0;
    min-width: 0;
    gap: 5px;
    padding: 9px 4px;
    font-size: 11px;
    white-space: nowrap;

    .tab-label-full {
      display: none;
    }

    .tab-label-mobile {
      display: inline;
    }
  }
`;

const TabCount = styled.span`
  min-width: 26px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #334155;
  font-size: 12px;
  font-weight: 900;

  @media (max-width: 768px) {
    min-width: 21px;
    height: 21px;
    padding: 0 5px;
    font-size: 10px;
  }
`;
